'use client';

import Link from 'next/link';
import { useRouter } from 'next/navigation';
import { ArrowLeft } from 'lucide-react';

export default function NotFound() {
  const router = useRouter();

  return (
    <div className="flex flex-col items-center justify-center min-h-screen px-4 py-16 bg-[#F5F8F9]">
      <div className="text-center p-8 bg-white rounded-2xl shadow-lg border border-[#E4E8EA]">
        <h1 className="text-7xl font-bold text-[#0D373D]">404</h1>
        <h2 className="mt-4 text-2xl font-semibold text-[#4D4F52]">
          Page Not Found
        </h2>
        <p className="mt-2 text-[#7A7D81] text-lg">
          The page you are looking for doesn't exist or has been moved.
        </p>
        <div className="mt-8">
          <button
            onClick={() => router.back()}
            className="inline-flex items-center px-6 py-3 text-white bg-[#2E7D32] rounded-xl hover:bg-[#25662A] transition-colors focus:outline-none focus:ring-2 focus:ring-[#2E7D32] focus:ring-offset-2 focus:ring-offset-white"
          >
            <ArrowLeft size={20} className="mr-2" />
            Go Back
          </button>
        </div>
      </div>
    </div>
  );
}
